import { FC, PropsWithChildren } from 'react';
import { Stack, Typography } from '@mui/material';

import { FontWeights } from '../../config';

export const PageWrapper: FC<PropsWithChildren & { title: string; subTitle: string }> = ({
  children,
  title,
  subTitle,
}) => (
  <Stack sx={{ m: '0 auto', mt: '21px', mb: { xs: 15, md: '100px' }, maxWidth: 610 }} alignItems="center">
    <Typography variant="h1" fontWeight={FontWeights.Light} textAlign="center">
      {title}
    </Typography>
    <Typography textAlign="center">{subTitle}</Typography>
    {children}
  </Stack>
);
